"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExtentColor = exports.getScaleColor = exports.createScaleValues = void 0;
const colors_1 = require("../../utilities/colors");
const createScaleValues = function (numBins) {
  let minimum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let maximum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  if (numBins.length < 2 || typeof minimum !== 'number' || typeof maximum !== 'number') {
    return [];
  }
  if (maximum <= minimum) {
    return [];
  }
  const step = (maximum - minimum) / numBins;
  return Array.apply(null, Array(numBins + 1)).map((emptyCell, i) => minimum + step * i);
};
exports.createScaleValues = createScaleValues;
const getScaleColor = (value, valuesArray, colorScale) => {
  if (value === null || value === undefined) {
    return (0, colors_1.parseColor)('usa-gray');
  }
  const maxIndex = Math.min(valuesArray.length - 2, colorScale.length - 1);
  const binIndex = Math.max(Math.min(valuesArray.filter(tickValue => value > tickValue).length - 1, maxIndex), 0);
  return (0, colors_1.parseColor)(colorScale[binIndex], 'usa-gray');
};
exports.getScaleColor = getScaleColor;
const getExtentColor = (value, values, colorScale) => {
  if (value === null || value === undefined) {
    return (0, colors_1.parseColor)('usa-gray');
  }
  const color = (0, exports.getScaleColor)(value, values, colorScale);
  const binNumber = colorScale.indexOf(color);
  if (binNumber * 2 === values.length - 2) {
    return '#212121';
  }
  return binNumber * 2 < values.length - 1 ? colorScale[0] : colorScale[values.length - 2];
};
exports.getExtentColor = getExtentColor;